import { render, staticRenderFns } from "./PreOrderTermAndCondition.vue?vue&type=template&id=22b5c860&scoped=true&"
import script from "./PreOrderTermAndCondition.vue?vue&type=script&lang=js&"
export * from "./PreOrderTermAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./PreOrderTermAndCondition.vue?vue&type=style&index=0&id=22b5c860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5c860",
  null
  
)

export default component.exports